import { UseFormReturn, Controller } from "react-hook-form";
import TextField from "@/components/TextField";
import Button from "@/components/Button";
import classNames from "classnames";
import { NumberFormatBase } from "react-number-format";

interface EventAttendanceFormData {
  estimatedParents: number;
  estimatedCoaches: number;
  estimatedOtherAttendees: number;
}

interface EditEventAttendanceCardProps {
  form: UseFormReturn<EventAttendanceFormData>;
  onSubmit: (formData: EventAttendanceFormData) => void;
  onCancel: () => void;
  isSubmitting: boolean;
}

export default function EditEventAttendanceCard({
  form,
  onSubmit,
  onCancel,
  isSubmitting
}: EditEventAttendanceCardProps) {
  return (
    <div className="space-y-6 w-full">
      <div className="col-span-full">
        <Controller
          control={form.control}
          name="estimatedParents"
          render={({ field }) => (
            <NumberFormatBase
              label="Estimated Parents"
              className="w-full"
              value={field.value || 0}
              format={(value) => value.toLocaleString()}
              customInput={TextField}
              onValueChange={(values) => {
                field.onChange(values.floatValue || 0);
              }}
            />
          )}
        />
      </div>
      <div className="col-span-full">
        <Controller
          control={form.control}
          name="estimatedCoaches"
          render={({ field }) => (
            <NumberFormatBase
              label="Estimated Coaches"
              className="w-full"
              value={field.value || 0}
              format={(value) => value.toLocaleString()}
              customInput={TextField}
              onValueChange={(values) => {
                field.onChange(values.floatValue || 0);
              }}
            />
          )}
        />
      </div>
      <div className="col-span-full">
        <Controller
          control={form.control}
          name="estimatedOtherAttendees"
          render={({ field }) => (
            <NumberFormatBase
              label="Estimated Students/Athletes/Attendees"
              className="w-full"
              value={field.value || 0}
              format={(value) => value.toLocaleString()}
              customInput={TextField}
              onValueChange={(values) => {
                field.onChange(values.floatValue || 0);
              }}
            />
          )}
        />
      </div>
      <div className="flex justify-end gap-2 mt-4">
        <Button variant="outlined" disabled={isSubmitting} onClick={onCancel}>
          Cancel
        </Button>
        <Button
          iconClassName={classNames(isSubmitting && "animate-spin w-6 h-6 !block")}
          disabled={isSubmitting}
          icon={isSubmitting ? "progress_activity" : undefined}
          onClick={() => onSubmit(form.getValues())}
        >
          Save
        </Button>
      </div>
    </div>
  );
}
